// @ts-nocheck
import React, { createContext, useCallback, useContext, useState } from 'react';

const RequirementContext = createContext({});

// O valor guardado em localStorage precisa ser sempre UM objeto (o
// requisito/processo selecionado). O botão de impressão do Card gravava
// um array com um item, e as páginas de procuração e de emissão de
// certidão leem `requirement.proxy_form_path` / `requirement.reference_id`
// direto — com um array no lugar, tudo vinha undefined e a página quebrava
// (e o link do Typeform de certidão saía sem os hidden fields). Normaliza
// na entrada e na leitura, pra valores antigos já gravados também.
const normalizar = (valor) => {
  if (Array.isArray(valor)) return valor[0] ?? {};
  return valor ?? {};
};

// A impressão "de todos os processos" (botão da Home) precisa da lista
// inteira — guardar só o primeiro item fazia a listagem sair com um
// requerente só (PT9932, 08/10/2026). `lista` é sempre um array.
const normalizarLista = (valor) => {
  if (Array.isArray(valor)) return valor.filter(Boolean);
  return valor && Object.keys(valor).length ? [valor] : [];
};

export const RequirementProvider = ({ children }) => {
  const lerGravado = () => {
    const getRequirement = localStorage.getItem('@Central:requirement');

    if(getRequirement) {
      try {
        return JSON.parse(getRequirement);
      } catch (e) {
        return null;
      }
    }

    return null;
  };

  const [requirement, setRequirement] = useState(() => normalizar(lerGravado()));
  const [lista, setLista] = useState(() => normalizarLista(lerGravado()));

  const addRequirement = useCallback((object) => {
    // Grava o valor original (objeto ou lista): as páginas de procuração e
    // de emissão leem `requirement` (um objeto); a impressão lê `lista`.
    localStorage.setItem('@Central:requirement', JSON.stringify(object ?? {}));

    setRequirement(normalizar(object));
    setLista(normalizarLista(object));
  }, []);

  const removeRequirement = useCallback(() => {
    localStorage.removeItem('@Central:requirement');

    setRequirement({});
    setLista([]);
  }, []);

  return (
    <RequirementContext.Provider value={{ addRequirement, removeRequirement, requirement, lista }}>
      {children}
    </RequirementContext.Provider>
  );
}

export const useRequirement = () => {
  const context = useContext(RequirementContext);

  if(!context) {
    throw new Error('useRequirement só pode ser usado com o RequirementProvider');
  }

  return context;
}
